import { RequestState } from "src/interfaces/RequestState";
import { RESET_REQUEST_STATE } from "./action";

const isRequest = ( type : string ) => type.toLowerCase().includes("request");
const isSuccessful = ( type : string ) => type.toLowerCase().includes("success");
const isError = ( type : string ) => type.toLowerCase().includes("error");
const getBaseRequest = (type : string) => type.match(/^([a-z]+\_)+REQUEST/gi)[0];



export default (state = {}, action) => {

    if (action.type == RESET_REQUEST_STATE){
        if (action.payload && Object.keys(action.payload).length > 0){
            let currentState = {...state};
            Object.values(action.payload)
                .forEach((key : string) => {
                    delete currentState[key];
                });
            return currentState;
        } else {
            return {};
        }
    }

    if (isRequest(action.type)){
        return {
            ...state,
            [getBaseRequest(action.type)]: {
                pending: !isError(action.type) && !isSuccessful(action.type),
                error: isError(action.type),
                success: isSuccessful(action.type),
                type: getBaseRequest(action.type)
            }
        }
    }

    return state;
}